import React, { useEffect } from 'react';
import { Brain, BarChart, Shield, Globe, Activity, Search } from 'lucide-react';
import './techpredLandingPage.css';
import { useNavigate } from 'react-router';
import { useTechPredAuth } from './Auth/TechPredAuthProvider';

const features = [
  {
    icon: <Brain className="icon" />,
    title: 'AI-Driven Insights',
    description: 'Get accurate predictions about upcoming tech trends powered by advanced neural models.'
  },
  {
    icon: <BarChart className="icon" />,
    title: 'Market Analysis',
    description: 'Analyze current technology markets to forecast which tools and frameworks will rise or fall.'
  },
  {
    icon: <Shield className="icon" />,
    title: 'Risk Prediction',
    description: 'Identify risks in adopting new tech early through predictive modeling and usage history.'
  },
  {
    icon: <Globe className="icon" />,
    title: 'Global Trends Monitoring',
    description: 'Track global shifts in software, hardware, and data technologies with real-time updates.'
  },
  {
    icon: <Activity className="icon" />,
    title: 'Innovation Scoring',
    description: 'Score technologies based on innovation, adoption, and longevity metrics.'
  },
  {
    icon: <Search className="icon" />,
    title: 'Tech Watchlist',
    description: 'Curate a personalized list of emerging tech to monitor based on your preferences.'
  }
];

const LandingTechPred = () => {
  const navigate = useNavigate();
  const { isTechPredAuthenticated } = useTechPredAuth();

  useEffect(() => {
    if (isTechPredAuthenticated) navigate('/techpred/chat');
  }, []);
  return (
    <div className="techpred">
      <div className="container">
        <div className="wrapper">
          {/* Hero Section */}
          <div className="hero">
            <h1 className="hero-title">
              Technology <span className="highlight">Prediction</span> Platform
            </h1>
            <p className="hero-description">
              Stay ahead by understanding tomorrow's tech — today. Get forecasts, risk analysis, and innovation scores in one place.
            </p>
          </div>

          {/* Features Section */}
          <div className="features-box">
            <h2 className="features-heading">What This Platform Offers</h2>
            <div className="features-grid">
              {features.map((feature, idx) => (
                <FeaturePoint key={idx} {...feature} />
              ))}
            </div>
          </div>

          {/* Call to Action */}
          <div className="cta">
            <button className="cta-button" onClick={() => navigate('/techpred/login')}>
              Start Predicting Now
            </button>
            <p className="cta-note">Explore tomorrow’s tech today • No setup required</p>
          </div>
        </div>
      </div>
    </div>
  );
};

const FeaturePoint = ({ icon, title, description }) => (
  <div className="feature-point">
    <div className="icon-container">{icon}</div>
    <div>
      <h3 className="feature-title">{title}</h3>
      <p className="feature-description">{description}</p>
    </div>
  </div>
);

export default LandingTechPred;
